import React from 'react'
import { useReactiveVar } from '@apollo/client'

import { BusinessInfo, EditorTextBlock } from 'components'
import { Products, ProjectMetrics } from 'modules/Projects/containers'
import { activeProjectTabVar } from 'modules/Projects/store'
import { LocalTourDates } from 'modules/TourDates/containers'
import { useLocalProjectFlags, useProjectParent } from 'modulesCommon/serviceHooks'
import { getFieldTitle } from 'modules/Projects/utils'
import { activeProjectVar } from 'modulesCommon/store'
import { IProject } from 'shared/interfaces'

const ProjectDetailLeftSide = () => {
  const activeProjectTab = useReactiveVar(activeProjectTabVar)
  const activeProject = useReactiveVar<IProject>(activeProjectVar)
  const { isLocalized } = useLocalProjectFlags(activeProject)
  const projectParent = useProjectParent(activeProject)

  if (isLocalized && activeProjectTab === 'projectInfo') {
    return (
      <>
        <EditorTextBlock info={projectParent?.team_info ?? ''} title={getFieldTitle('team_info', true)} isProject field="team_info" />
        <EditorTextBlock info={projectParent?.info ?? ''} title={getFieldTitle('info', true)} isProject field="info" />
      </>
    )
  }

  return activeProjectTab !== 'products' ? (
    <>
      <ProjectMetrics />
      <Products />
      {
        activeProjectTab === 'stories' ? (
          <div style={{ marginTop: 20 }}>
            <LocalTourDates />
          </div>
        ) : null
      }
      <BusinessInfo />
    </>
  ) : null
}

export default ProjectDetailLeftSide
